var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.partyListLoading,
      expression: "partyListLoading"
    }],
    staticClass: "module-left"
  }, [_c('div', {
    staticClass: "mettingList scrollbar"
  }, [_c('div', {
    staticClass: "globalControlBox"
  }, [_vm.gcList.length ? _c('el-tree', {
    ref: "globalTree",
    staticClass: "globalTree",
    attrs: {
      "data": _vm.gcList,
      "props": _vm.defaultProps,
      "node-key": "id",
      "default-expanded-keys": [_vm.gcList[0] && _vm.gcList[0].id]
    },
    on: {
      "node-expand": _vm.getCurrentGCParty,
      "node-click": _vm.changeParty
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        node,
        data
      }) {
        return _c('div', {}, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !data.edit,
            expression: "!data.edit"
          }],
          staticClass: "title",
          attrs: {
            "title": _vm.returnTitleText(node, data)
          }
        }, [_vm._v(_vm._s(_vm.returnTitleText(node, data)))]), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !data.edit,
            expression: "!data.edit"
          }],
          staticClass: "partyNumber",
          attrs: {
            "title": _vm.returnContent(node, data)
          }
        }, [_vm._v(_vm._s(_vm.returnContent(node, data)))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false"
          }]
        }, [_vm._v(_vm._s(data.edit))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false"
          }]
        }, [_vm._v(_vm._s(data))]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: data.edit,
            expression: "data.edit"
          }],
          staticClass: "edit left"
        }, [_c('el-input', {
          ref: `input${(node === null || node === void 0 ? void 0 : node.level) == 1 ? data.globalControlId : data.partyCode}`,
          staticClass: "renameInput",
          attrs: {
            "maxlength": 32
          },
          on: {
            "blur": function ($event) {
              return _vm.renameGlobal(node, data, 'blur');
            }
          },
          nativeOn: {
            "keyup": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.saveGlobalName(data, node);
            },
            "click": function ($event) {
              $event.stopPropagation();
              return (() => {}).apply(null, arguments);
            }
          },
          model: {
            value: data.editName,
            callback: function ($$v) {
              _vm.$set(data, "editName", $$v);
            },
            expression: "data.editName"
          }
        }), data.redTip ? _c('p', [_vm._v(_vm._s(data.redMessage))]) : _vm._e()], 1), _c('el-popover', {
          attrs: {
            "placement": "bottom",
            "width": "308",
            "popper-class": "sideTips",
            "trigger": "click",
            "visible-arrow": "false"
          },
          model: {
            value: data.visible,
            callback: function ($$v) {
              _vm.$set(data, "visible", $$v);
            },
            expression: "data.visible"
          }
        }, [_c('div', {
          staticClass: "popupBox"
        }, [_c('div', {
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.renameGlobal(node, data);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit grayColor"
        }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.rename')))])]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (node === null || node === void 0 ? void 0 : node.level) == 1,
            expression: "node?.level == 1"
          }],
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.deleteGlobal(data);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete grayColor"
        }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.delete')))])]), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (node === null || node === void 0 ? void 0 : node.level) != 1,
            expression: "node?.level != 1"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: _vm.copyGlobalParty(data),
            expression: "copyGlobalParty(data)",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: _vm.onCopy,
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: _vm.onError,
            expression: "onError",
            arg: "error"
          }],
          staticClass: "joinBtn font_16",
          attrs: {
            "icon": "el-icon-link"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.hideGlobalPopup(data);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.copyLink')))]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (node === null || node === void 0 ? void 0 : node.level) != 1,
            expression: "node?.level != 1"
          }],
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.removeParty(data, node);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete grayColor"
        }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.remove')))])])], 1), _c('i', {
          staticClass: "el-icon-more",
          attrs: {
            "slot": "reference"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return (() => {}).apply(null, arguments);
            }
          },
          slot: "reference"
        })])], 1);
      }
    }], null, false, 2606609647)
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.gcList.length && !_vm.partyListLoading,
      expression: "!gcList.length && !partyListLoading"
    }],
    staticClass: "noDataText"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.noGlobalText')) + " ")])], 1)]), _c('div', {
    staticClass: "createPartyBox pointer",
    class: {
      threeTab: _vm.conferenceMode
    },
    on: {
      "click": function ($event) {
        return _vm.createMeeting();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`commonPartyHost.leftPane.${_vm.type}`)) + " ")])]), _vm.removeInfoTips.show ? _c('TipsDailog', {
    attrs: {
      "info": _vm.removeInfoTips
    },
    on: {
      "save": function ($event) {
        return _vm.onSureDeleteParty(_vm.deleteInfo.item);
      }
    }
  }) : _vm._e(), _vm.globalControlInfoTips.show ? _c('TipsDailog', {
    staticClass: "globalControl",
    attrs: {
      "info": _vm.globalControlInfoTips,
      "notClose": true,
      "width": "550px"
    },
    on: {
      "save": _vm.saveControl,
      "cancel": function ($event) {
        _vm.globalName = '';
      }
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.controlName')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#FF4B4B"
    }
  }, [_vm._v("*")]), _c('el-input', {
    staticClass: "editInput",
    class: {
      redBorder: _vm.showEmptyName
    },
    attrs: {
      "maxlength": 32
    },
    on: {
      "blur": _vm.blurName
    },
    model: {
      value: _vm.globalName,
      callback: function ($$v) {
        _vm.globalName = $$v;
      },
      expression: "globalName"
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEmptyName,
      expression: "showEmptyName"
    }],
    staticStyle: {
      "color": "red",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.nameIsRequired')))]), _c('div', {
    staticClass: "partyListBox"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.mode')) + ":")]), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.title.kiosk')))])]), _c('div', {
    staticClass: "list scrollbar"
  }, _vm._l(_vm.kioskPartyList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "listLi",
      class: {
        disabled: item.belongToGlobalControl && !_vm.globalControlInfoTips.edit,
        hadSelect: _vm.returnClass(item)
      }
    }, [_c('div', {
      staticClass: "contentLeft"
    }, [item.title ? _c('p', {
      staticClass: "title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('p', {
      staticClass: "title",
      attrs: {
        "title": new Date(item.createTime).toLocaleDateString() + '  ' + new Date(item.createTime).toLocaleTimeString()
      }
    }, [_vm._v(_vm._s(new Date(item.createTime).toLocaleDateString()) + " " + _vm._s(new Date(item.createTime).toLocaleTimeString()))]), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.topContent.partyId')) + ": " + _vm._s(_vm._f("returnStrByInfo")(item.partyCode)))])]), _c('div', {
      staticClass: "contentRight"
    }, [_c('el-checkbox', {
      attrs: {
        "disabled": _vm.returnDisabled(item)
      },
      on: {
        "change": val => {
          _vm.savePartyInfo(val, item);
        }
      },
      model: {
        value: item.checked,
        callback: function ($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    })], 1)]);
  }), 0)]), _c('el-divider', {
    staticClass: "partyListDivider"
  }), _c('p', {
    staticClass: "select"
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.partySelect')) + " " + _vm._s(_vm.returnNumber))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };